export default "__VITE_ASSET__25c478ec__"